import $axios from "../api/accessor";
import { $api } from "../api/api";

export const InnovationServices = {
  async GetInnovations(url?: string) {
    let response = await $axios
      .get(url || $api("get_innovations"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async GetInnovationBySlug(category: string, slug: string) {
    let response = await $axios
      .get($api("get_singleNews", { category, slug }), {
        headers: { "Accept-Language": "az" },
      })
      .catch((err) => err.response);
    return { data: response?.data || null, status: response?.status };
  },
};
